const reservation = {
  en: {
    translation: {
      today: "today",
      tomorrow: "tomorrow",
      choose_time: "Select time *",
      label_phone: "Phone number *",
      label_name: "First name *",
      label_firstName: "First name *",
      label_lastName: "Last name *",
      label_email: "Email *",
      label_details: "Do you have a special request?",
      people: "people",
      person: "person",
      book: "book a table",
      error_message_phone: "Please, add a phone number",
      error_message_email: "Please, add an e-mail address",
      error_message_name: "Please, write your first name",
      error_message_last_name: "Please, write your last name",
      error_message_time: "Please, select a time",
      error_send_mail:
        "Something went wrong! Please try again in a few minutes or call",
      email_sent_label:
        "Thank you, we will respond to your request as soon as possible",
      sent_email_title: "Thank you!",
      sent_email_label: "We will respond to your request as soon as possible",
      sent_email_label_1: "You will receive a response from",
      sent_email_label_2: "within",
      sent_email_extra_label:
        "Please note that your reservation is not confirmed until you receive an e-mail or an sms from the selected business.",
      sent_email_text: "Our staff will contact you as soon as possible.",
      error_api_reservation_601_1:
        "It looks like you've already made a similar request. For assistance call",
      error_api_reservation_601_2: "at",
      error_api_reservation_602:
        "A similar request has been rejected, check your e-mail for more info. For assistance call",
      error_api_reservation_603:
        "A similar request has been confirmed, check your e-mail for more info. For assistance call",
      owner_has: "Owner has",
      to_responde_you: "to respond you",
      timer_explanation: "will respond to your request in:",
      no_times_available: "There are no tables available",
      toc1: 'Clicking on "BOOK A TABLE", you agree to our ',
      toc2: "Terms and Conditions",
      toc3: " and confirm to have read our ",
      toc4: "Privacy Policy",
      toc5: " and ",
      toc6: "Cookie Policy",
      compulsory_fields: "* required fields"
    }
  },
  it: {
    translation: {
      today: "oggi",
      tomorrow: "domani",
      choose_time: "Scegli un orario *",
      label_phone: "Telefono *",
      label_name: "Nome *",
      label_firstName: "Nome *",
      label_lastName: "Cognome *",
      label_email: "Email *",
      label_details: "Hai richieste speciali?",
      people: "persone",
      person: "persona",
      book: "prenota un tavolo",
      error_message_phone: "Per favore, aggiungi un numero di telefono",
      error_message_email: "Per favore, aggiungi un indirizzo email",
      error_message_name: "Per favore, scrivi il tuo nome",
      error_message_last_name: "Per favore, scrivi il tuo cognome",
      error_message_time: "Per favore, scegli un orario",
      error_send_mail:
        "Qualcosa è andato storto! Per favore riprova tra qualche minuto o contatta",
      email_sent_label:
        "Grazie, riceverai una risposta nel più breve tempo possibile",
      sent_email_title: "Grazie!",
      sent_email_label: "Riceverai una risposta nel più breve tempo possibile",
      sent_email_label_1: "Riceverai una risposta da",
      sent_email_label_2: "entro",
      sent_email_extra_label:
        "La prenotazione non è confermata finché non si riceve un sms o un'e-mail dalla struttura selezionata.",
      sent_email_text:
        "Abbiamo ricevuto la tua richiesta, il nostro staff ti ricontatterà al più presto.",
      error_api_reservation_601_1:
        "Sembra che tu abbia già effettuato una richiesta simile. Per assistenza contatta",
      error_api_reservation_601_2: "al numero",
      error_api_reservation_602:
        "Sembra che tu abbia già effettuato una richiesta simile e che non sia stata confermata, controlla la tua e-mail per maggiori informazioni. Per assistenza contatta",
      error_api_reservation_603:
        "Sembra che tu abbia già effettuato una richiesta simile e che sia stata confermata, controlla la tua e-mail per maggiori informazioni. Per assistenza contatta",
      owner_has: "L'owner ha",
      to_responde_you: "per risponderti",
      timer_explanation: "risponderà alla tua richiesta entro:",
      no_times_available: "Non ci sono tavoli disponibili",
      toc1: "Cliccando su “PRENOTA UN TAVOLO”, accetti i nostri  ",
      toc2: "Termini e Condizioni",
      toc3: " e confermi di aver letto le nostre ",
      toc4: "Privacy Policy",
      toc5: " e ",
      toc6: "Cookie Policy",
      compulsory_fields: "* campi obbligatori"
    }
  }
};

export default reservation;
